import React from "react";
import liveOrderCard from "../components/live-order-card.png";
import { StoreCardForTimesail } from "../../../components/store-card/store-card-for-timesail";
import { formatDateToYearMonthDayDayOfWeek } from "../../../utils/date/format-date";
import { HiCamera } from "react-icons/hi";

const LiveOrderGuide: React.FC = () => {
  return (
    <>
      {/* 메인 히어로 섹션 */}
      <div className="relative aspect-[940/768] overflow-hidden">
        <img
          src={liveOrderCard}
          alt="실시간팩 이용 안내"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4 w-full">
          <h2
            className="font-bold text-gray-900 leading-tight"
            style={{ fontSize: "calc(100vw * 0.074)" }}
          >
            올라온 순간 매진, 선착순 티켓팅
          </h2>
          <p className="mt-1 font-medium text-xl text-gray-700">
            지금 주문하고 바로 픽업해요
          </p>
          <div className="flex mt-1.5">
            <div className="bg-blue-100 text-blue-600 text-lg px-2 py-1 rounded-full border-2 border-blue-600 font-bold">
              실시간팩
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-6 p-2">
        {/* 01. 실시간팩이란? */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-blue-500 font-bold text-3xl">01.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              실시간팩이란?
            </span>
          </div>
          <div className="space-y-1">
            <p className="text-gray-700 text-md">
              실시간팩은 지금 주문하고 바로 픽업할 수 있는 서비스예요. 재고가
              있는 상품을 즉시 구매하고 매장에서 수령해요.
            </p>
            <p className="text-gray-700 text-md break-keep">
              실시간팩은 마감 시간에{" "}
              <span className="font-semibold">
                매장에서 확인된 상품이 올라오기 때문에
              </span>{" "}
              , 구매 전에 어떤 메뉴가 들어있는지{" "}
              <span className="font-semibold text-blue-600">메뉴 확인</span>이
              가능해요.
            </p>
          </div>
        </section>
        {/* 02. 상품 확인 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-blue-500 font-bold text-3xl">02.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              상품을 확인해요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            실시간으로 업로드된 상품을 확인해요
          </p>
          <div className="pointer-events-none bg-gray-50 border border-gray-200 rounded-xl">
            <StoreCardForTimesail
              title="치즈 베이커리"
              closingHours="20:00"
              discountPrice={3000}
              price={6000}
              onClick={() => {}}
              img="https://cdn-mahi.com/1729044908670-%ED%81%AC%EB%A6%A0%EC%B9%98%EC%A6%88%EB%B2%A0%EC%9D%B4%EA%B8%80.avif"
              distance={1}
              products={[
                {
                  id: 1,
                  store: {
                    id: 1,
                    title: "치즈 베이커리",
                    img: "https://cdn-mahi.com/1729044908670-%ED%81%AC%EB%A6%A0%EC%B9%98%EC%A6%88%EB%B2%A0%EC%9D%B4%EA%B8%80.avif",
                    createdAt: new Date(),
                    updatedAt: new Date(),
                    reviewCount: 100,
                    signupState: "승인",
                    isPackOrderLimitConfigEnabled: false,
                    todaysProducts: [],
                    searchKeywords: [],
                  },
                  img: "https://cdn-mahi.com/1755780340169-ChatGPT%20Image%20Aug%2021",
                  name: "치즈 크로와상 2개",
                  userPrice: 3000,
                  quantity: 2,
                  createdAt: new Date(),
                  updatedAt: new Date(),
                  price: 3000,
                  currentCount: 10,
                  currentPurchasedCount: 0,
                  soldQuantity: 0,
                  discountRate: 60,
                  discountPrice: 3000,
                  isDeleted: false,
                  isEnd: false,
                  isSampleMenu: false,
                  isSoldout: false,
                },
                {
                  id: 2,
                  store: {
                    id: 1,
                    title: "치즈 베이커리",
                    img: "https://cdn-mahi.com/1729044908670-%ED%81%AC%EB%A6%A0%EC%B9%98%EC%A6%88%EB%B2%A0%EC%9D%B4%EA%B8%80.avif",
                    createdAt: new Date(),
                    updatedAt: new Date(),
                    reviewCount: 100,
                    signupState: "승인",
                    isPackOrderLimitConfigEnabled: false,
                    todaysProducts: [],
                    searchKeywords: [],
                  },
                  img: "https://cdn-mahi.com/1755780340169-ChatGPT%20Image%20Aug%2021",
                  name: "치즈 크로와상 3개",
                  userPrice: 4000,
                  quantity: 3,
                  createdAt: new Date(),
                  updatedAt: new Date(),
                  price: 3000,
                  currentCount: 10,
                  currentPurchasedCount: 0,
                  soldQuantity: 0,
                  discountRate: 60,
                  discountPrice: 3000,
                  isDeleted: false,
                  isEnd: false,
                  isSampleMenu: false,
                  isSoldout: false,
                },
              ]}
              likeCount={100}
            />
          </div>
        </section>
        {/* 03. 즉시 주문 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-blue-500 font-bold text-3xl">03.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              바로 주문해요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            원하는 메뉴를 고르고 장바구니에 담아 결제해요.
          </p>

          <div className="flex flex-col gap-y-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            {[
              {
                id: 1,
                name: "치즈 크로와상 2개",
                quantity: 5,
                price: 6000,
                userPrice: 3000,
                img: "https://cdn-mahi.com/1755780340169-ChatGPT%20Image%20Aug%2021",
                isDeleted: false,
                isEnd: false,
                isSampleMenu: false,
              },
              {
                id: 2,
                name: "베이글 (크림치즈) 1개",
                quantity: 3,
                price: 4000,
                userPrice: 2500,
                img: "https://cdn-mahi.com/1755780340169-ChatGPT%20Image%20Aug%2021",
                isDeleted: false,
                isEnd: false,
              },
              {
                id: 3,
                name: "치즈 샌드위치 1개",
                quantity: 0,
                price: 3500,
                userPrice: 2000,
                img: "https://cdn-mahi.com/1755780340169-ChatGPT%20Image%20Aug%2021",
                isDeleted: false,
                isEnd: false,
                isSampleMenu: false,
              },
            ].map((product) => (
              <div
                key={product.id}
                className="w-full flex rounded-[0.625rem] overflow-hidden border border-[#F9F9F9] bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)]"
              >
                <div className="relative w-[137px] h-[137px]">
                  <img
                    src={product.img}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                  {product.isEnd && product.quantity !== 0 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-l-lg">
                      <span className="text-white text-xl font-semibold">
                        판매종료
                      </span>
                    </div>
                  )}
                  {product.quantity === 0 && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-l-lg">
                      <span className="text-white text-xl font-semibold">
                        품절
                      </span>
                    </div>
                  )}
                  {product.isSampleMenu && (
                    <div className="absolute top-2 left-2 bg-pink-500 px-2 py-1 flex items-center justify-center rounded-lg">
                      <span className="text-white text-base font-semibold">
                        이벤트
                      </span>
                    </div>
                  )}
                </div>

                <div className="p-4 w-full h-full flex flex-col justify-between">
                  <div className="text-black text-lg font-semibold">
                    {product.name}
                  </div>
                  <div className="bg-[#f3f3f3] px-2 pb-1 rounded-md w-fit mt-2">
                    <span className="text-black text-xs font-bold">
                      {product.quantity}개
                    </span>
                    <span className="text-black text-xs font-normal">
                      {" "}
                      남았어요!
                    </span>
                  </div>
                  {product.quantity !== 0 && !product.isEnd && (
                    <div className="mt-1 w-full flex items-center justify-end">
                      <div className="mr-3 mt-0.5 text-md sm:text-2xl text-red-400 line-through font-semibold">
                        {product.price.toLocaleString()}원
                      </div>
                      <div className="text-lg sm:text-xl text-black font-bold">
                        {product.userPrice?.toLocaleString()}원
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 04. 픽업 진행 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-blue-500 font-bold text-3xl">04.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              픽업은 이렇게 진행돼요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3 break-keep">
            주문 할 때에 언제 픽업할 것인지 직접 정해요. 픽업 시간은 마감시간
            전까지만 가능해요.
          </p>

          <div className="flex flex-col items-center justify-center bg-gray-50 rounded-lg p-4 border border-gray-200 pointer-events-none">
            <input
              type="time"
              value={"19:45"}
              className="mx-4 mt-6 p-4 rounded-lg font-bold text-lg"
              style={{ fontSize: "1.5rem", height: "3rem" }}
            />
            <div className="flex items-center my-6 space-x-2">
              <button className="p-2 bg-red-100 text-red-500 rounded-lg">
                -10분
              </button>
              <button className="p-2 bg-red-100 text-red-500 rounded-lg">
                -5분
              </button>

              <button className="p-2 bg-[#1692fc] text-white rounded-lg">
                +5분
              </button>
              <button className="p-2 bg-[#1692fc] text-white rounded-lg">
                +10분
              </button>
            </div>
          </div>
        </section>
        {/* 05. 픽업 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-blue-500 font-bold text-3xl">05.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              내가 정한 픽업시간에 맞춰 방문해요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            매장의 픽업시간은{" "}
            <span className="font-bold">주문내역 &gt; 상세보기</span>에서 확인할
            수 있어요.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 space-y-2 pt-4 border border-gray-200">
            <div className="pb-4">
              <div className="text-center space-y-1">
                <div className="text-xl font-black text-gray-900 tracking-wide">
                  {formatDateToYearMonthDayDayOfWeek(new Date())}
                </div>
                <div className="text-2xl font-black text-blue-600 tracking-wide">
                  19:45
                </div>
              </div>
            </div>
            <div className="p-4 bg-blue-600/90 rounded-lg">
              <div className="text-center space-y-2">
                <p className="text-lg font-medium break-keep text-white text-center">
                  <span className="font-black tracking-wider underline underline-offset-4 text-xl">
                    꼭 픽업시간에 맞춰
                  </span>{" "}
                  픽업을 해주세요!
                </p>
                <p className="text-md text-white font-black break-keep">
                  픽업 시간은 사장님과 약속한 시간이에요.
                </p>
                <div className="flex flex-col gap-1">
                  <p className="text-lg text-white font-medium flex items-center justify-center gap-2">
                    <HiCamera className="text-2xl" />
                    픽업 후 바로 사진 남기기!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-gray-600 flex justify-end mt-2">
            <p className="text-sm font-bold">[ 주문내역 &gt; 상세보기 ]</p>
          </div>
        </section>
        {/* 06. 주문코드 제시 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-blue-500 font-bold text-3xl">06.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              주문코드를 직원에게 보여주세요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            <span className="font-bold">주문내역 &gt; 상세보기</span>에서{" "}
            <span className="font-bold">주문코드</span>를 확인하고 매장 직원에게
            보여주세요.
          </p>

          {/* 주문코드 예시 */}
          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-700">주문 코드</span>
                <span className="text-lg font-bold text-blue-600">
                  빠른 히어로
                </span>
              </div>
              <div className="border-t border-gray-200 pt-3">
                <div className="flex items-start bg-white rounded-lg border-b last:border-none p-2">
                  <img
                    src="https://cdn-mahi.com/1729044908670-%ED%81%AC%EB%A6%A0%EC%B9%98%EC%A6%88%EB%B2%A0%EC%9D%B4%EA%B8%80.avif"
                    alt="치즈 베이커리"
                    className="w-[120px] h-[120px] object-cover rounded-lg"
                  />
                  <div className="ml-3 flex flex-col flex-1">
                    <p className="font-bold text-gray-900 mb-1">
                      치즈 크로와상 2개
                    </p>
                    <p className="text-gray-700">1개 구매</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-gray-600 flex justify-end mt-2">
            <p className="text-sm font-bold">[ 주문내역 &gt; 상세보기 ]</p>
          </div>
        </section>
        {/* 07. 직원 픽업 완료 처리 */}
        <section className="rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-blue-500 font-bold text-3xl">07.</span>
            <span className="text-gray-800 font-bold text-2xl break-keep">
              직원이 픽업 완료 버튼을 눌러요
            </span>
          </div>
          <p className="text-gray-600 text-md mb-3">
            매장에서 상품을 받고 직원이 픽업 완료 처리를 해요.
          </p>

          <div className="text-center bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex flex-col items-center">
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={true}
                  readOnly
                />
                <div className="w-[138px] h-16 rounded-full shadow-inner transition-colors duration-300 bg-blue-500"></div>
                <div className="absolute w-12 h-12 bg-white rounded-full shadow-lg transform transition-transform duration-300 ease-in-out translate-x-[82px]"></div>
              </label>

              <div className="text-gray-900 text-base font-bold mt-2">
                직원 확인 버튼
              </div>
              <div className="text-md text-gray-700">
                이 화면을 직원에게 보여주시고 눌러달라고 해주세요
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 pb-8">
          <a
            href="http://pf.kakao.com/_xawxcRn/chat"
            className="w-full bg-blue-500 text-white font-semibold py-3 px-6 rounded-lg flex items-center justify-center gap-2 hover:bg-blue-500/90 transition-colors shadow-md hover:shadow-lg"
          >
            <span>💬</span>
            문의사항이 있으신가요?
          </a>
        </section>
      </div>
    </>
  );
};

export default LiveOrderGuide;
